<template>
    <Row :gutter="20"> 
        <!-- <Col span='8' style="border-right: 1px solid #eee;">
            <seasonEdit :sport_id="sport_id" :season_id="season_id" ></seasonEdit>
        </Col>
        <Col span='16' style="border-left: 1px solid #eee;">
            <tournamentList :sport_id="sport_id" :season_id="season_id" ></tournamentList>
        </Col> -->
        <matchMap :sport_id="sport_id" :season_id="season_id"></matchMap>
    </Row>
</template>
<script>

// import seasonEdit from './edit.vue';
// import tournamentList from '../tournament/list.vue';
import matchMap from '../match_up/map.vue';

export default {
    name: "season-detail",
    props: {
        sport_id: Number,   // 运动id
        season_id: Number,   // 联赛id
    },
    components: {
        // seasonEdit,
        // tournamentList
        matchMap,
    },
    data () {
        let self = (window.x = this)
        return {
        }
    },
    methods: {
    },
    mounted () {
    },
    watch: {
    },
    computed: {
    }
}
</script>

<style scoped>
    /* @import "detail.css" */
</style>